/**
 * Moderation Active Moderators Panel
 *
 * Displays the number of active moderators
 */

import { Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationActiveModeratorsPanelProps {
  activeModerators: number;
  isLoading?: boolean;
}

export function ModerationActiveModeratorsPanel({ activeModerators, isLoading = false }: ModerationActiveModeratorsPanelProps) {
  if (isLoading) {
    return (
      <div className={styles.panel}>
        <div className={styles.header}>
          <span className={styles.title}>ACTIVE MODERATORS</span>
        </div>
        <div className={styles.content}>
          <Shimmer className={styles.shimmerValue} label="Loading active moderators count" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.title}>ACTIVE MODERATORS</span>
      </div>
      <div className={styles.content}>
        <Text as="div" className={styles.value}>
          {activeModerators}
        </Text>
        <Text as="div" className={styles.subtitle}>
          Currently online
        </Text>
      </div>
    </div>
  );
}
